export default "__VITE_PUBLIC_ASSET__7d04318b__"